import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  popper: {
    boxShadow: '0 4px 7px 0 rgba(0,0,0,0.2)',
  },
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: 'var(--accent-default)',
      color: 'white',
    },
  },
  input: {
    height: 44,
    '&::placeholder': {
      verticalAlign: 'center',
      paddingLeft: 10,
    },
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
